import React from 'react'

import { CobrandingLogo } from '@frame/ui-components/cobranding-logo'
import { BaseWidgetHeader } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { Card } from '@frame/ui-primitives/card'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import expired from '@frame/images/expired.svg'
import { useStore } from '@frame/lib/stores/useStore'
import { getVerifierDisplayName } from '@frame/lib/utils/session'
import { DataAttribute } from '@frame/types'

export function Expired() {
  const { id, verifierName, closeable, tenantPropertyName, verifierType } = useStore((state) => ({
    id: state.session?.id || state.instanceId,
    verifierName: state.session?.originating_party_display_name,
    closeable: state.session?.consumer_initiated,
    tenantPropertyName: state.session?.configuration?.cobranding?.tenant_property?.property_name,
    verifierType: state.session?.verifier_type,
  }))

  const displayName = getVerifierDisplayName(verifierType, verifierName, tenantPropertyName)

  return (
    <>
      <BaseWidgetHeader />
      <Body
        data-cy={DataAttribute.SCREEN_TERMINAL_EXPIRED}
        hasBackgroundColor={false}
        paddingTopOverride={0}
        className="p-5"
      >
        <CobrandingLogo />
        <H2 className="my-5 text-center">Session is expired</H2>
        <P>
          {closeable ? (
            <>This link has expired. Please refresh the page to start over.</>
          ) : (
            <>
              <P>
                This link has expired. {displayName} will try verifying your details via other verification methods.
              </P>
              <P className="mt-4">
                If you have questions about the verification process, please reach out to your contact
                {displayName ? ` at ${displayName}` : ''}.
              </P>
            </>
          )}
        </P>
        {id && (
          <Card className="mt-4 w-full break-words px-4 py-3 font-mono">
            <P variant="xsmall">{id}</P>
          </Card>
        )}
        <img src={expired} className="mx-auto mt-5 max-w-[191px]" />
      </Body>
    </>
  )
}
